<woa-modal-page-layout [title]="'woa.heading.marketing.title'" [contentText]="instructions()">
    <woa-form (onSubmit)="confirmDetails()">
        @if (showMobilePhone()) {
            <woa-phone-number-field [(ngModel)]="mobilePhone" name="mobilePhone"
                                    [label]="'woa.label.common.mobile'" [required]="!showEmail"
                                    woa-phone-number></woa-phone-number-field>
        }
        @if (showEmail()) {
            <woa-email-field [(ngModel)]="email" name="email"
                             [label]="'woa.label.common.email'" [required]="!showMobilePhone()"
                             woa-email></woa-email-field>
        }
        @if (showPostCode()) {
            <woa-text-field [(ngModel)]="postCode" name="postCode"
                            [label]="'woa.label.address.postCode'" [maxlength]="'10'"
                            [autocomplete]="'postal-code'" [spellcheck]="false"></woa-text-field>
        }
    </woa-form>
    <woa-button woa-page-footer-control [label]="'woa.button.marketing.marketingOptIn'"
                (onActivate)="form().submit()"></woa-button>
</woa-modal-page-layout>
